import { render, staticRenderFns } from "./SalesManager.vue?vue&type=template&id=2f9e4667&scoped=true"
import script from "./SalesManager.vue?vue&type=script&lang=js"
export * from "./SalesManager.vue?vue&type=script&lang=js"
import style0 from "./SalesManager.vue?vue&type=style&index=0&id=2f9e4667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e4667",
  null
  
)

export default component.exports